module.exports = __webpack_public_path__ + "static/media/premium_s1.5ffc63ff.png";